import designationAttributes from "./designation-attribute.json";

export default { ...designationAttributes };
